import React, { useMemo } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import moment from "moment";
import Icon from "components/icon";
import withStyles from "components/with-styles";
import styles from "./styles/duration-humanizer.css.js";
import getHumanizer from "./partial/humanizer-with-gl";

const MINUTE_MILISECONDS = 60 * 1000;
const HOUR_MILISECONDS = 60 * MINUTE_MILISECONDS;

const DurationHumanizer = ({ intl, classes, start, end, maxInterval = 3 * HOUR_MILISECONDS, minInterval = 0 }) => {
  const milliseconds = Math.max(0, moment.duration(moment(end).diff(moment(start))).asMilliseconds());
  const humanizer = useMemo(() => getHumanizer(intl.locale), [intl.locale]);

  const offlimits = milliseconds <= 0 || milliseconds > maxInterval || milliseconds < minInterval;

  return (
    <span className={cn({ [classes.offlimits]: offlimits })}>
      <FormattedMessage id="common.date.duration.label" values={{ duration: humanizer(milliseconds) }} />
      {offlimits && <Icon className={classes.icon_warning} name="warning" />}
    </span>
  );
};

DurationHumanizer.propTypes = {
  /**
   * Fecha inicio del intervalo
   */
  start: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Fecha fin del intervalo
   */
  end: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * Duración máxima en milisegundos para mostrar la alerta. Por defecto interval > 3h.
   */
  maxInterval: PropTypes.number,
  /**
   * Duración mínima en milisegundos para mostrar la alerta. Por defecto interval < 0.
   */
  minInterval: PropTypes.number,
};

export default injectIntl(withStyles(styles)(DurationHumanizer));
